"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[897],{

/***/ 897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_PaymentBanner; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(4141);
// EXTERNAL MODULE: ./hooks/useModal.ts
var useModal = __webpack_require__(7206);
// EXTERNAL MODULE: ./components/Login/login.tsx
var login = __webpack_require__(4636);
// EXTERNAL MODULE: ./components/modal/index.tsx
var modal = __webpack_require__(9485);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./context/authContext.tsx + 41 modules
var authContext = __webpack_require__(6348);
// EXTERNAL MODULE: ./supabase.ts + 34 modules
var supabase = __webpack_require__(8555);
// EXTERNAL MODULE: ./components/PaymentModal/index.tsx
var PaymentModal = __webpack_require__(4133);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/CompanyLogos/index.tsx






function CompanyLogos() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "bg-white dark:bg-gray-900 mb-2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "max-w-screen-xl px-4 pb-8 mx-auto text-center lg:pb-16 lg:px-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("figure", {
          className: "max-w-screen-md mx-auto",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
            className: "h-12 mx-auto mb-3 text-gray-400 dark:text-gray-600",
            viewBox: "0 0 24 27",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z",
              fill: "currentColor"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("blockquote", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-2xl font-medium text-gray-900 dark:text-white",
              children: "\u201CUiland is just awesome. It contains over 50,000 mobile and web app screens from real world design inspiration . Perfect choice for discovering UI patterns and flows from different apps\u201D"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("figcaption", {
            className: "flex items-center justify-center mt-6 space-x-3",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              className: "w-6 h-6 rounded-full",
              src: "/assets/img/tassy.jpeg",
              alt: "profile picture"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center divide-x-2 divide-gray-500 dark:divide-gray-700",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "pr-3 font-medium text-gray-900 dark:text-white",
                children: "Atasie Esther"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "pl-3 text-sm font-light text-gray-500 dark:text-gray-400",
                children: "Product Designer at Aether(YC W24)"
              })]
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "px-4 mx-auto text-center overflow-hidden  lg:px-36",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "font-semibold font-silka text-gray-400 uppercase",
        children: "Top choice by design teams at"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap justify-center items-center mt-8 text-gray-500 sm:justify-between",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(AnimationDiv, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-white ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "Ebay"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "Moniepoint"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "Hyundai"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "Fairmoney"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "SeamlessHR"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "YellowCard"
            })
          }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "Testgorilla"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "Klasha"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "Sofaboda"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-white ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "Paystack"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "Flutterwave"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "AfriChange"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "Fairmoney"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mr-5 mb-5 lg:mb-0 hover:text-gray-800 dark:hover:text-gray-400",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-5xl font-bold font-silka ",
              children: "SeamlessHR"
            })
          })]
        })
      })]
    })]
  });
}

var AnimationDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyLogos__AnimationDiv",
  componentId: "sc-1je7tw9-0"
})(["white-space:nowrap;width:100vw;-webkit-animation:tickerScroll 40s linear infinite normal;animation:tickerScroll 40s linear infinite normal;-webkit-animation-delay:1s;animation-delay:1s;opacity:0;-webkit-transform:translateX(0);transform:translateX(0);transition:all linear;will-change:transform,opacity;display:flex;flex-direction:row;gap:60px;@keyframes tickerScroll{0%{opacity:1;-webkit-transform:translateX(0);transform:translateX(0);}to{opacity:1;-webkit-transform:translateX(-1937px);transform:translateX(-1937px);}}"]);
/* harmony default export */ var components_CompanyLogos = (CompanyLogos);
;// CONCATENATED MODULE: ./components/PaymentBanner/index.tsx
















var PaymentBanner = function PaymentBanner(_ref) {
  var count = _ref.count,
      showPaymentBanner = _ref.showPaymentBanner,
      _ref$flows = _ref.flows,
      flows = _ref$flows === void 0 ? false : _ref$flows;

  var _useModal = (0,useModal/* default */.Z)(),
      loginToggleModal = _useModal.loginToggleModal,
      isModalLogin = _useModal.isModalLogin,
      paymentShowModal = _useModal.paymentShowModal,
      paymenttoggleModal = _useModal.paymenttoggleModal;

  var user = (0,react.useContext)(authContext/* UserContext */.St);
  var router = (0,next_router.useRouter)();

  var handleSignupWithGoogle = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0,supabase/* signInWithGoogle */.qj)(router.asPath);

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.log('Sorry an error occurred while trying to login');

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function handleSignupWithGoogle() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isModalLogin && /*#__PURE__*/(0,jsx_runtime.jsx)(modal["default"], {
      toggleModal: loginToggleModal,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(login["default"], {
        toggleModal: loginToggleModal
      })
    }), paymentShowModal && /*#__PURE__*/(0,jsx_runtime.jsx)(modal["default"], {
      toggleModal: paymenttoggleModal,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentModal/* default */.Z, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Overlay, {
      flows: flows
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MainWrapper, {
      children: showPaymentBanner === "non-paying" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(PaymentButton, {
        children: [flows ? "Subscribe to View Flows of All ".concat(count, " App").concat(count > 1 ? "s" : "") : "Subscribe to View All ".concat(count, " Screens"), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return paymenttoggleModal();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Unlock Premium"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(PaymentButton, {
        children: ["Sign In to View More Screens", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          onClick: function onClick() {
            return handleSignupWithGoogle();
          },
          className: "flex items-center ",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            style: {
              width: '30px',
              height: '30px'
            },
            className: "h-30 mr-2",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 48 48",
              width: "100%",
              height: "100%",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                fill: "#FFC107",
                d: "M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                fill: "#FF3D00",
                d: "M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                fill: "#4CAF50",
                d: "M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                fill: "#1976D2",
                d: "M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
              })]
            })
          }), "Sign In With Google", ' ']
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_CompanyLogos, {})]
  });
};

var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentBanner__Overlay",
  componentId: "sc-a57928-0"
})(["height:200px;width:100%;margin-top:", ";background-image:linear-gradient( to bottom,#ffffff,#fafbff,#f3f7ff,#eaf4ff,#e0f1ff );filter:blur(35px);opacity:0.8;box-shadow:-80px -80px 50px rgba(255,255,255,0.4),-30px -30px 20px rgba(255,255,255,0.8);"], function (_ref3) {
  var flows = _ref3.flows;
  return flows ? '-350px' : '-250px';
});
var PaymentButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentBanner__PaymentButton",
  componentId: "sc-a57928-1"
})(["font-size:20px;font-weight:800;color:#000000;text-align:center;@media (min-width:768px){font-size:36px;:span{font-size:18px;}}span{margin-top:0.5em;font-weight:500;cursor:pointer;width:250px;font-size:14px;display:flex;color:#ffffff;padding:0.8em;padding:0.8em;margin:1em auto;margin:1em auto;justify-content:center;border-radius:50px;background-color:var(--primary-color);border:1px solid #8798be;}span{margin-top:0.5em;font-weight:500;cursor:pointer;width:250px;font-size:14px;display:flex;color:white;padding:0.8em;margin:1em auto;justify-content:center;border-radius:50px;background-color:var(--primary-color);border:1px solid #8798be;}"]);
var MainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentBanner__MainWrapper",
  componentId: "sc-a57928-2"
})(["height:300px;z-index:98;margin-top:-100px;width:100%;background-image:linear-gradient( to bottom,#ffffff,#ffffff,#ffffff,#ffffff,#ffffff );box-shadow:-80px -80px 50px rgba(255,255,255,0.4),-30px -30px 20px rgba(255,255,255,1);display:flex;align-items:center;justify-content:center;position:relative;"]);
/* harmony default export */ var components_PaymentBanner = (PaymentBanner);

/***/ })

}]);